// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-oneOf-1-1!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-2!./index.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "\n.tips[data-v-106c86ed] {\n  color: #b4b2b2;\n  font-size: 12px;\n  line-height: 13px;\n  display: inline-block;\n}\n.color-DF303A[data-v-106c86ed] {\n  color: #df303a;\n  font-size: 14px;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
